module.exports = __webpack_public_path__ + "static/media/notfound-1200.fc944eaa.jpg";